import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Snackbar } from '@mui/material';
import { useCookies } from 'react-cookie';

export default function CookiesBanner() {
  const [open, setOpen] = useState(false);
  const [cookies, setCookie] = useCookies(['cookiesAccepted']);

  useEffect(() => {
    if (!cookies.cookiesAccepted) {
      setOpen(true);
    }
  }, [cookies.cookiesAccepted, setCookie]);

  const handleAccept = () => {
    setOpen(false);
    setCookie('cookiesAccepted', 'true', {
      path: '/',
      maxAge: 60 * 60 * 24 * 365, // 1 year expiration
      secure: true,
      sameSite: 'strict'
    });
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ width: '65%', bottom: 0, mb: 0, pb: 0, transform: 'none'}}
    >
      <Box
        sx={{
          backgroundColor: '#05112a',
          color: 'white',
          p: 3,
          width: '100%',
          maxWidth: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'flex-start', md: 'center' },
          justifyContent: 'center',
          borderRadius: 0,
        }}
      >
        <Box sx={{ maxWidth: 1000, mr: { xs: 0, md: 4 } }}>
          <Typography variant="body1" component="div" sx={{ mb: 1 }}>
            <strong>Privacy and cookies</strong>
          </Typography>
          <Typography variant="body2" sx={{ mb: { xs: 2, md: 0 } }}>
            We use cookies that are essential for this website to function properly. These cookies are strictly necessary
            to provide you with the services available through our website and to use some of its features.
          </Typography>
        </Box>
        <Button
          variant="outlined"
          color="inherit"
          onClick={handleAccept}
          sx={{
            borderColor: 'white',
            borderRadius: 8,
            px: 3,
            minWidth: 100,
            alignSelf: { xs: 'flex-start', md: 'center' }
          }}
        >
          Okay
        </Button>
      </Box>
    </Snackbar>
  );
}